// ANT Modules
import { Select } from "antd";

// Constants & Utils
import { RETRO_CLAIM_PAYMENT_MODE } from "constants/global";
import { PAYMENT_MODE_OPTIONS } from "utils/paymentMode";
import getIcon from "utils/getIcon";
import theme from "styles/theme";

const { Option } = Select;

export type PaymentModeSelectProps = {
	value?: string;
	disabled?: boolean;
	className?: string;
	onChange: (value: string) => void;
};

// Payment mode dropdown styled consistently with the outlet selector.
const PaymentModeSelect = ({ value, disabled, className, onChange }: PaymentModeSelectProps): JSX.Element => {
	return (
		<Select
			data-testid={RETRO_CLAIM_PAYMENT_MODE.LABEL}
			disabled={disabled}
			className={className}
			placeholder={RETRO_CLAIM_PAYMENT_MODE.SELECT_LABEL}
			optionFilterProp="children"
			onChange={onChange}
			value={value || undefined}
			listHeight={325}
			style={{ width: "100%", minWidth: "12.5rem" }}
			popupClassName="left-nav-search-dropdown"
			dropdownStyle={{ backgroundColor: theme.dropdownStyle.backgroundColor, boxShadow: "none" }}
			suffixIcon={<span>{getIcon({ icon: "" })}</span>}
		>
			{PAYMENT_MODE_OPTIONS.map((mode) => (
				<Option key={mode} value={mode} className="flex-col px-2 py-2">
					{mode}
				</Option>
			))}
		</Select>
	);
};

export default PaymentModeSelect;
